export default __webpack_public_path__ + "static/media/waiting_for_result.997e1c4f.svg";